<template>
  <v-container fluid justify-start>
    <!-- Data Table -->
    <v-data-table
      :headers="headers"
      :items="invitations"
      :search="search"
      :custom-filter="messageFilter"
      :loading="isLoading"
      item-key="id"
      :no-data-text="noDataText"
      class="elevation-2"
      >
      <v-progress-linear slot="progress" :color="appColor_Progress" indeterminate></v-progress-linear>
      <template v-slot:top>

        <!-- Header Toolbar -->
        <v-toolbar dense flat dark :color="appColor_Medium">

          <app-back-button v-bind:color="appColor_Dark" />     

          <!--<v-icon large class="mr-2" :color="appColor_Abby">picture_in_picture</v-icon>-->
          <v-toolbar-title>Ambient Invitations</v-toolbar-title>
          
          <v-spacer />

          <!-- Edit Dialog -->
          <v-toolbar-items>
            <v-dialog
              v-model="editDialog"
              max-width="400px"
              :persistent="true"
              >
              <loading slot="layout" :active.sync="isLoadingDialog" :can-cancel="false" loader="dots" :color="appColor_Progress"></loading>
              <template v-slot:activator="{ on }">
                <v-btn v-if="isSmallDevice" slot="activator" small :color="appColor_Dark" dark class="mb-1 mt-0 mr-0 elevation-0" v-on="on">New</v-btn>
                <v-btn v-else slot="activator" :color="appColor_Dark" class="mb-1 mt-0 mr-0 elevation-0" v-on="on">Create Invitation</v-btn>
              </template>
              <v-card>
                <v-toolbar dense dark flat :color="appColor_Medium">
                  <v-toolbar-title><v-icon>edit</v-icon> {{ formTitle }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-0 pt-2 ma-0">
                  <v-container grid-list-md class="pt-0 pb-0">
                    <form>
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            v-model="editedInvitation.message"
                            label="Message"
                            v-validate="'required|max:200'"
                            :error-messages="errors.collect('message')"
                            data-vv-name="message"
                            ref="message"
                            hide-details="auto"
                          >
                        </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-checkbox
                            v-model="editedInvitation.isDefault"
                            :color="appColor_Selected"
                            label="Set as Default"
                            hide-details
                            >
                          </v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-checkbox
                            v-model="editedInvitation.isExecuteRandom"
                            :color="appColor_Selected"
                            label="Activate Response"
                            hide-details
                            >
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click.native="closeDialog">Cancel</v-btn>
                  <v-btn :color="appColor_Medium" text @click.native="save">Save</v-btn>
              </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar-items>
        </v-toolbar>

        <v-row class="mx-0">
          
          <!-- Search -->
          <v-col cols="12" md="12">
            <v-text-field
              v-model="search"
              append-icon="search "
              label="Search"
              single-line
              hide-details
              clearable
              :disabled="isLoading"
              :class="filterClass" 
              >
            </v-text-field>
          </v-col>
        </v-row>
        
      </template>
      
      <template v-slot:item.message="{ item }">
        <span class="text-left">
          <router-link to="/abbyAmbientInvitationManager">
            <span @click="edit(item)">{{ item.message }}</span>
          </router-link>
        </span>
      </template>

      <template v-slot:item.isDefault="{ item }">
        <v-icon v-if="item.isDefault" :color="appColor_Selected">done</v-icon>
      </template>

      <template v-slot:item.isExecuteRandom="{ item }">
        <v-icon v-if="item.isExecuteRandom" :color="appColor_Selected">done</v-icon>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon v-if="item.canDelete" @click="remove(item)">delete</v-icon>
        <v-icon v-else color="grey lighten-1">delete</v-icon>
      </template>
    </v-data-table>

  </v-container>
</template>

<script>
import appService from '@/app.service'
import { AppColor } from '@/config.js'
import AppBackButton from '@/components/App/AppBackButton'

export default {
  name: 'AbbyAmbientInvitationManager',
  components: {
    AppBackButton
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {

      // colors
      appColor_Medium: AppColor.Medium,
      appColor_Dark: AppColor.Dark,
      appColor_DeleteButton: AppColor.DeleteButton,
      appColor_Progress: AppColor.Progress,
      appColor_Abby: AppColor.KioskTypeAbby,
      appColor_Selected: AppColor.Selected,

      isLoading: true,
      isSaving: false,
      isLoadingDialog: false,
      editDialog: false,
      search: '',
      invitations: [],
      headers: [
        {
          text: 'ID',
          value: 'id',
          align: 'left',
          width: '5%',
          class: 'pr-0'
        },
        {
          text: 'Message',
          value: 'message',
          align: 'left',
          width: '60%',
          class: 'pr-0'
        },
        {
          text: 'Default',
          value: 'isDefault',
          align: 'center',
          width: '15%',
          class: 'pr-0'
        },
        {
          text: 'Activate Response',
          value: 'isExecuteRandom',
          align: 'center',
          width: '15%',
          class: 'pr-0'
        },
        {
          value: 'action',
          sortable: false,
          align: 'center',
          width: '5%'
        }
      ],
      editedIndex: -1,
      editedInvitation: {
        id: -1,
        message: null,
        isDefault: false,
        isExecuteRandom: false
      },
      defaultInvitation: {
        id: -1,
        message: null,
        isDefault: false,
        isExecuteRandom: false
      },
      dictionary: {
        custom: {
          message: {
            required: () => 'Message is required',
            max: 'Description must be 50 characters or less'
          }
        }
      }
    }
  },
  computed: {
    noDataText () {
      if (this.isLoading) return 'One moment...'

      return this.invitations.length === 0
        ? 'No Ambient Invitations found'
        : ''
    },
    formTitle () {
      return this.editedInvitation.id < 0 ? 'New Invitation' : 'Edit Invitation'
    },
    filterClass () {
      return this.$vuetify.breakpoint.name === 'lg' 
        || this.$vuetify.breakpoint.name === 'md' 
        ? 'ml-0'
        : 'ml-0'
    }
  },
  methods: {
    loadData () {
      const self = this
      self.isLoading = true
      appService.getAbbyAmbientInvitations().then(data => {
        if (data.errorSeverity > 0) {
          self.handleError(data)
        } else {
          self.invitations = data.invitations
        }
        self.isLoading = false
      }).catch(e => { self.handleCriticalError(e) })
    },

    edit (item) {
      const self = this
      self.isLoadingDialog = true
      self.editedIndex = self.invitations.indexOf(item)
      self.editedInvitation = Object.assign({}, item)
      self.editDialog = true
      setTimeout(() => {
        self.isLoadingDialog = false
      }, 100)
    },

    remove (item) {
      const self = this
      const index = self.invitations.indexOf(item)
      const message = self.invitations[index].message

      self.$confirm.show({
        title: 'Delete Invitation?',
        text: `<b>${message}</b>`,
        onConfirm: () => {
          appService.deleteAbbyAmbientInvitation(item.id).then((data) => {
            if (data.errorSeverity > 0) {
              self.handleError(data)
            } else {
              self.invitations.splice(index, 1)
            }
          }).catch(e => { self.handleCriticalError(e) })
        }
      })
    },

    save () {
      const self = this
      self.$validator.validateAll().then(valid => {
        if (valid) {
          const isEditMode = self.editedIndex > -1
          self.isSaving = true

          if (isEditMode) {
            var editedInvitation = self.invitations[self.editedIndex]
            Object.assign(editedInvitation, self.editedInvitation)
            const invitationModel = self.getModel(editedInvitation, true)
            appService.updateAbbyAmbientInvitation(editedInvitation.id, invitationModel).then((data) => {
              if (data.errorSeverity !== null) {
                self.handleError(data)
              }
              self.isSaving = false
              self.closeDialog()
            }).catch(e => { self.handleCriticalError(e) })
          } else {
            const invitationModel = self.getModel(self.editedInvitation, false)
            appService.addAbbyAmbientInvitation(invitationModel).then((data) => {
              if (data.errorSeverity !== null) {
                self.handleError(data)
              } else {
                self.editedInvitation.id = data.invitation.id
                self.invitations.unshift(self.editedInvitation)
              }
              self.isSaving = false
              self.closeDialog()
            }).catch(e => { self.handleCriticalError(e) })
          }
        }
      })
    },

    getModel (i) {
      return {
        id: i.id,
        message: i.message,
        isExecuteRandom: i.isExecuteRandom
      }
    },

    closeDialog () {
      const self = this
      self.editDialog = false
      setTimeout(() => {
        self.resetEditedInvitation()
        self.isLoadingDialog = false
      }, 300)
    },

    resetEditedInvitation () {
      this.editedInvitation = Object.assign({}, this.defaultInvitation)
      this.editedIndex = -1
      this.$validator.reset()
    },

    messageFilter (value, search, item) {
      return value != null &&
        search != null &&
        item.message.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
    },

    handleError (result) {
      this.$error.show({
        title: result.errorSeverity === 0
                      ? 'Validation Failed'
                      : 'Internal Error',
        text: result.errorMessage,
        severity: result.errorSeverity
      })
    }
  },
  created() {
    this.loadData()
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
  },
  watch: {
    editDialog (val) {
      if (val) {
        const self = this
        setTimeout(() => {
          // set focus to message input in the edit dialog
          self.$refs.message.focus()
        }, 300)
      } else {
        this.closeDialog()
      }
    }
  }
}
</script>

<style scoped>
.custom-highlight-row{
  background-color: rgb(255, 255, 144);
}
</style>
